/*  eslint-disable */
import moment from "moment";
import _ from "lodash";

const SPAZIO = " ";

const generaLayout = (impostazioni, sorgente, cliente, pagamenti) => {
  let codici = [];
  const valoreIvato = _.get(impostazioni, "valoreIvato", true);
  if (sorgente) {
    for (const riga of sorgente.righe) {
      let st = printReceiptRow(riga, valoreIvato);
      codici = codici.concat(st.righe);
    }
  }
  let template = _.cloneDeep(_.get(impostazioni, "template", []));
  let comandi = [];
  for (let c of codici) {
    let descrizione = impostazioni.uCaseDescrizioni
      ? c.descrizione.toUpperCase()
      : c.descrizione;
    const maxLen = impostazioni.lunghezzaTestoDescrizione || 42;
    let valore = c.valore ? parseFloat(c.valore).toFixed(2) : "";
    let qta = String(c.quantita || ""); // per idTavolo altrimenti undefined
    let lenResidua = maxLen - valore.length - qta.length - 6; // abbiamo messo da -4 a -6 perchè altrimenti sulla fattura non si vedevano i decinali dei prodotti
    comandi.push(
      ` ${qta} ${descrizione
        .substring(0, lenResidua)
        .padEnd(lenResidua, " ")} ${valore}`
    );
  }
  let fattura = replaceInfoFattura(
    template,
    sorgente,
    cliente,
    pagamenti,
    comandi,
    impostazioni
  );
  return fattura;
};

const printReceiptRow = (riga, valoreIvato) => {
  let righe = [];
  let desc = riga.descrizione;
  var pattern = /[()"/]+/gi;
  desc = desc.replace("&", "+");
  desc = desc.replace(pattern, "_");
  desc = sanitize(desc);
  if (riga.rigaDescrittiva) {
    righe.push({ descrizione: desc });
  } else {
    const reparto = riga.repartoFiscale || 1;
    const qta = riga.quantita;
    let v1 = valoreIvato
      ? +parseFloat(
          riga.valore ? riga.valore.importoTotale : riga.importoTotale
        ).toFixed(2)
      : +parseFloat(
          riga.valore ? riga.valore.importoNettoTotale : riga.importoNettoTotale
        ).toFixed(2);

    righe.push({
      descrizione: desc,
      quantita: qta,
      codice: riga.prodotto ? riga.prodotto.codice : riga.codice,
      valore: v1
    });
  }
  return { righe };
};

const replaceInfoFattura = function(
  comandi,
  sorgente,
  cliente,
  pagamenti,
  righe,
  impostazioni
) {
  const noteTestata = sorgente
    ? sorgente.righe.filter(
        x =>
          x.tipo === "descrizione" &&
          x.payload &&
          x.payload.destinazione === "comanda" &&
          x.payload.posizione === "testata"
      )
    : [];
  const maxLen = _.get(impostazioni, "lunghezzaTestoDescrizione") || 42;
  let info = [];
  var v;
  for (let i = 0; i < comandi.length; i++) {
    let ii = comandi[i];
    if (ii.text && ii.text.length > 0) {
      let stg = JSON.stringify(ii.text);
      do {
        v = getParametro(stg, "{{", "}}");
        if (v) {
          const defaultV1 = ii.v1_default || "";
          stg = stg.replace(`{{${v}}}`, _.get(sorgente, v) || defaultV1);
        }
      } while (v);
      stg = stg.replace("#now#", moment().format("DD/MM/YYYY HH:mm"));
      stg = stg.replace("#now_sd#", moment().format("DD/MM/YY HH:mm"));
      stg = stg.replace("#date#", moment().format("DD/MM/YYYY"));
      stg = stg.replace("#time#", moment().format("HH:mm"));
      ii.text = JSON.parse(stg);
    }
    if (ii.code === "noteTestata") {
      if (noteTestata.length > 0) {
        const maxLen = ii.v1 || 42;
        for (let n of noteTestata) {
          const regEx = new RegExp("/(.{" + maxLen + "})/gy");
          const testi =
            n.descrizione.length > maxLen
              ? n.descrizione.split(regEx)
              : [n.descrizione];
          for (let t of testi) {
            info.push(t);
          }
        }
      }
      ii = null;
      continue;
    }
    if (ii.code === "aliquote") {
      if (sorgente) {
        const alqs = Object.keys(sorgente.totali);
        for (let alq of alqs.filter(x => x !== "generale")) {
          const al = sorgente.totali[alq];
          info.push(`${"Aliquota".padEnd(15, " ")}${al.ivaCodice}%`);
          info.push(`${"Imponibile".padEnd(15, " ")}${al.imponibile}`);
          info.push(`${"Imposta".padEnd(15, " ")}${al.iva}`);
        }
      }
      ii = null;
      continue;
    }

    if (ii.code === "pagamento") {
      if (pagamenti) {
        const pgs = Object.keys(pagamenti);
        for (let pag of pgs) {
          const pg = pagamenti[pag];
          info.push(`${descPagamento(pag).padEnd(15, " ")}${pg}`);
        }
      }
      ii = null;
      continue;
    }
    if (ii.code === "body") {
      info = info.concat(righe);
      ii = null;
      continue;
    }
    // Se passa solo code --> inserisce automaticamente tutte le info del cliente
    // Se passa anche subCode --> inserisce solo la info richiesta
    if (ii.code === "cliente") {
      if (cliente && !ii.subCode) {
        const recapito = cliente.recapiti.find(
          x => x.tipo && x.tipo.codice === "principale"
        );
        info.push(_.get(cliente, "ragioneSociale"));
        info.push(
          _.get(cliente, "c_recapito.indirizzo") || recapito.indirizzo || ""
        );
        info.push(
          _.get(cliente, "c_recapito.localita") || recapito.localita || ""
        );
        const cap = _.get(cliente, "c_recapito.cap") || recapito.cap || "";
        const nomeProvincia =
          _.get(cliente, "c_recapito.nomeProvincia") ||
          recapito.nomeProvincia ||
          recapito.provincia ||
          "";
        info.push(`${cap} ${nomeProvincia}`);
        info.push(" ");
        info.push("piva: " + _.get(cliente, "amministrativi.partitaIva"));
        info.push(
          "cf: " +
            (_.get(cliente, "amministrativi.codiceFiscale", "") ||
              _.get(cliente, "amministrativi.partitaIva", ""))
        );
        if (_.get(cliente, "anagrafica.cliente.fatturazione.codiceSdi")) {
          info.push(
            "Codice Sdi: " +
              _.get(cliente, "anagrafica.cliente.fatturazione.codiceSdi", "")
          );
        } else if (_.get(cliente, "anagrafica.cliente.fatturazione.pec")) {
          info.push(
            "Pec: " + _.get(cliente, "anagrafica.cliente.fatturazione.pec", "")
          );
        }
      }
      if (cliente && ii.subCode) {
        info.push(_.get(cliente, ii.subCode, ""));
      }
      ii = null;
      continue;
    }
    // gestire allineamento
    let testo = ii.text;
    let prima = 0,
      dopo = 0;
    let lenTesto = testo.length;
    switch (ii.align) {
      case "center":
        prima = Math.round((maxLen - lenTesto) / 2);
        dopo = maxLen - prima - lenTesto;
        testo = _.repeat(" ", prima) + testo + _.repeat(" ", dopo);
        break;
      case "left":
        break;
      case "right":
        prima = maxLen - lenTesto;
        testo = _.repeat(" ", prima) + testo;
        break;
      default:
        break;
    }
    if (ii && ii.font && ii.font !== 1) {
      testo = `§${ii.font}§${testo}`;
    }
    ii && info.push(testo);
  }
  return info;
};

const descPagamento = codice => {
  switch (codice) {
    case "contanti":
      return "Contanti";
    case "cartadicredito":
      return "Carta di pagamento";
    case "buonipasto":
      return "Buoni pasto";
    case "buonimultiuso":
      return "Buoni multiuso";
    case "scontoapagare":
      return "Sconto a pagare";
    default:
      return codice;
  }
};

const getParametro = function(valore, inizio, fine) {
  let a = valore.indexOf(inizio);
  let b = valore.indexOf(fine || inizio);
  let v = a > -1 ? valore.substring(a + 2, b) : "";
  return v;
};

export const sanitize = function(text, toLower) {
  let res = text
    .replace("ù", `u'`)
    .replace("à", `a'`)
    .replace("ò", `o'`)
    .replace("ì", `i'`)
    .replace("è", `e'`)
    .replace("é", `e'`);
  return toLower ? res.toLowerCase() : res;
};

export default {
  generaLayout
};
